// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\PriceRuleResponse

import { BookingRuleType } from './enums.gen';

export type PriceRuleApiResponse = {
	type: BookingRuleType.Price;
	minPrice: number | null;
	maxPrice: number | null;
};

export type PriceRule = {
	type: BookingRuleType.Price;
	minPrice: number | null;
	maxPrice: number | null;
};

export function hydratePriceRule(data: PriceRuleApiResponse): PriceRule {
	return { ...data };
}